import React, { Component } from 'react'
import { Row, Col, Table, Icon, Popconfirm, Input, Button } from 'antd'
import DocsModel from '../models/DocsModel'
import AuthModel from '../models/AuthModel'
import { Link } from 'react-router-dom'
import moment from 'moment'
import Permissions from '../models/Permissions'

class AdminDocs extends Component {

    state = {
        filterTitleVisible: false,
        searchTitle: '',
        filterUserVisible: false,
        searchUser: '',
        data: [],
        typesOptions: []
    };

    componentWillReceiveProps(nextProps) {
        const typesOptions = [];
        nextProps.items.map((item) => {
            if (typesOptions.indexOf(item.label) === -1) {
                typesOptions.push({key: item.id, text: item.label, value: item.label});
            }
            item.key = item.id
            return item
        });
        this.setState({
            ...this.state,
            data: nextProps.items,
            typesOptions: typesOptions
        })
    }

    filter(field, query, data) {
        const reg = new RegExp(query, 'gi');
        const items = data.map((record) => {
            const match = record[field].match(reg);
            if (!match) return null;
            return {
                ...record,
                name: (
                <span>
                    {record[field].split(reg).map((text, i) => (
                    i > 0 ? [<span className="highlight">{match[0]}</span>, text] : text
                    ))}
                </span>
                ),
            };
        }).filter(record => !!record);
        return items;
    }

    onFilterTitleChange = (e) => {
        this.setState({
            ...this.state,
            searchTitle: e.target.value
        });
    }

    onResetTitle() {
        this.setState({
            ...this.state,
            searchTitle: '',
            filterTitleVisible: false
        });
    }

    onFilterUserChange = (e) => {
        this.setState({
            ...this.state,
            searchUser: e.target.value
        });
    }

    onResetUser() {
        this.setState({
            ...this.state,
            searchUser: '',
            filterUserVisible: false
        });
    }

    downloadAttach(record) {
        var attachBaseUrl = DocsModel.endpoint() + '/download'
        var url = attachBaseUrl+'/'+record.filename+'?token=' + AuthModel.getAuthToken() + '&id='+record.id
        DocsModel.download(record.descricao, url, record.mime)
    }

    render() {
        const { searchTitle } = this.state;
        var items = this.filter('title', searchTitle, this.props.items || []);
        const columns = [{
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            sorter: (a, b) => parseInt(a.id, 10) - parseInt(b.id, 10)
        },
        
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
            sorter: (a, b) => a.title >= b.title ? 1 : -1,
            filterDropdown: (
                <div className="custom-filter-dropdown">
                  <Input
                    ref={ele => this.inputTitleEl = ele}
                    placeholder="Pesquisar"
                    value={this.state.searchTitle}
                    onChange={this.onFilterTitleChange}
                  />
                  <Button type="danger" onClick={this.onResetTitle.bind(this)}>Reset</Button>
                </div>
            ),
            filterIcon: <Icon type="filter" style={{ color: this.state.searchTitle ? '#108ee9' : '#aaa' }} />,
            filterDropdownVisible: this.state.filterTitleVisible,
            onFilterDropdownVisibleChange: (visible) => {
                this.setState({
                    filterTitleVisible: visible,
                }, () => this.inputTitleEl.focus());
            },
            render: (text, r) => (
                <Link to={'/docs/'+r.id}>{text}</Link>
            )
        },
        
        {
            title: 'Tipo',
            dataIndex: 'type_id',
            key: 'type_id',
            sorter: (a, b) => a.type_id >= b.type_id ? 1 : -1,
            filters: this.state.typesOptions,
            filterMultiple: false,
            onFilter: (v, r) => r.label.indexOf(v) === 0,
            render: (text, record) => record.label
        },
        
        {
            title: 'Data',
            dataIndex: 'data',
            key: 'data',
            sorter: (a, b) => moment(a.data).isAfter(b.data) ? 1 : -1,
            render: (text, record) => moment(text).format('YYYY/MM/DD')
        },
        
        {
            title: 'Criado por',
            dataIndex: 'username',
            key: 'username',
            sorter: (a, b) => a.title >= b.title ? 1 : -1,
            render: (text, record) => record.username,
            filterDropdown: (
                <div className="custom-filter-dropdown">
                  <Input
                    ref={ele => this.inputUserEl = ele}
                    placeholder="Pesquisar"
                    value={this.state.searchUser}
                    onChange={this.onFilterUserChange}
                  />
                  <Button type="danger" onClick={this.onResetUser.bind(this)}>Reset</Button>
                </div>
            ),
            filterIcon: <Icon type="filter" style={{ color: this.state.searchUser ? '#108ee9' : '#aaa' }} />,
            filterDropdownVisible: this.state.filterUserVisible,
            onFilterDropdownVisibleChange: (visible) => {
                this.setState({
                    filterUserVisible: visible,
                }, () => this.inputUserEl.focus());
            }
        },
        
        {
            title: 'Opções',
            key: 'action',
            render: (text, record) => {
                return (
                    <span>
                        { record.filename ? (
                            <a role="button" target="_blank" onClick={(e) => this.downloadAttach(record)}>
                                <Icon type="download" style={{color: 'blue'}} />
                            </a>
                        ) : null }
                        { !Permissions.isDenied('docs', 'update', record) ? (
                            <span>
                                <span className="ant-divider" />
                                <Link to={'/docs/form/' + record.id}>
                                    <Icon type="edit" style={{color: 'green'}} />
                                </Link>
                            </span>
                        ) : '' }
                        { !Permissions.isDenied('docs', 'delete', record) ? (
                            <span>
                                <span className="ant-divider" />
                                <Popconfirm title="Confirma DESTRUIR o documento?"
                                    onConfirm={(e) => this.props.remove(record)}
                                    okText="Sim" cancelText="Não">
                                    <a role="button">
                                        <Icon type="delete" style={{color: 'red'}} />
                                    </a>
                                </Popconfirm>
                            </span>
                        ) : '' }
                    </span>
                )
            }
        }]
        
        return (
            <Row>
                <Col span={24}>
                    { !Permissions.isDenied('docs', 'create') ? (
                        <Link to={'/docs/form'} style={{float: 'right'}}>
                            <Icon type="edit" /> Novo Documento
                        </Link>
                    ) : null }
                    <br />
                    <hr style={{clear: 'both'}} />
                    <Table dataSource={items} columns={columns} />
                </Col>
            </Row>
        )
    }
}

export default AdminDocs;



// WEBPACK FOOTER //
// ./src/components/AdminDocs.js